import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewRunningApplications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0397 6.5326C12.1191 7.2747 12.716 7.87157 13.4577 7.95424C14.0087 8.01565 14.5743 8.06839 15.151 8.06839C15.7279 8.06839 16.2935 8.01565 16.8444 7.95424C17.5861 7.87157 18.1831 7.2747 18.2625 6.5326C18.321 5.98478 18.3706 5.42235 18.3706 4.84896C18.3706 4.27556 18.321 3.71312 18.2625 3.1653C18.1831 2.4232 17.5861 1.82635 16.8444 1.74367C16.2935 1.68226 15.7279 1.62952 15.151 1.62952C14.5743 1.62952 14.0087 1.68226 13.4577 1.74367C12.716 1.82635 12.1191 2.4232 12.0397 3.1653C11.9811 3.71312 11.9316 4.27556 11.9316 4.84896C11.9316 5.42235 11.9811 5.98478 12.0397 6.5326Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.73701 6.5326C1.81641 7.2747 2.41327 7.87157 3.155 7.95424C3.70594 8.01565 4.27161 8.06839 4.84835 8.06839C5.42509 8.06839 5.99076 8.01565 6.54169 7.95424C7.28342 7.87157 7.88028 7.2747 7.95968 6.5326C8.01829 5.98478 8.06778 5.42235 8.06778 4.84896C8.06778 4.27556 8.01829 3.71312 7.95968 3.1653C7.88028 2.4232 7.28342 1.82635 6.54169 1.74367C5.99076 1.68226 5.42509 1.62952 4.84835 1.62952C4.27161 1.62952 3.70594 1.68226 3.155 1.74367C2.41327 1.82635 1.81641 2.4232 1.73701 3.1653C1.6784 3.71312 1.62891 4.27556 1.62891 4.84896C1.62891 5.42235 1.6784 5.98478 1.73701 6.5326Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.73701 16.8349C1.81641 17.577 2.41327 18.1737 3.155 18.2565C3.70594 18.3179 4.27161 18.3706 4.84835 18.3706C5.42509 18.3706 5.99076 18.3179 6.54169 18.2565C7.28342 18.1737 7.88028 17.577 7.95968 16.8349C8.01829 16.2871 8.06778 15.7246 8.06778 15.1512C8.06778 14.5778 8.01829 14.0154 7.95968 13.4675C7.88028 12.7255 7.28342 12.1286 6.54169 12.0459C5.99076 11.9845 5.42509 11.9318 4.84835 11.9318C4.27161 11.9318 3.70594 11.9845 3.155 12.0459C2.41327 12.1286 1.81641 12.7255 1.73701 13.4675C1.6784 14.0154 1.62891 14.5778 1.62891 15.1512C1.62891 15.7246 1.6784 16.2871 1.73701 16.8349Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0397 16.8349C12.1191 17.577 12.716 18.1737 13.4577 18.2565C14.0087 18.3179 14.5743 18.3706 15.151 18.3706C15.7279 18.3706 16.2935 18.3179 16.8444 18.2565C17.5861 18.1737 18.1831 17.577 18.2625 16.8349C18.321 16.2871 18.3706 15.7246 18.3706 15.1512C18.3706 14.5778 18.321 14.0154 18.2625 13.4675C18.1831 12.7255 17.5861 12.1286 16.8444 12.0459C16.2935 11.9845 15.7279 11.9318 15.151 11.9318C14.5743 11.9318 14.0087 11.9845 13.4577 12.0459C12.716 12.1286 12.1191 12.7255 12.0397 13.4675C11.9811 14.0154 11.9316 14.5778 11.9316 15.1512C11.9316 15.7246 11.9811 16.2871 12.0397 16.8349Z",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgViewRunningApplications;
